// ── DB 관리 — 테이블 설명 & 타입 색상 상수 ───────────────────────────────────

// ─── 테이블별 기능 설명 맵 ───────────────────────────────────────────────────
// label  : 한 줄 요약 (무슨 데이터인가)
// pages  : 이 테이블을 사용하는 관리자/직원 기능 목록
// note   : (선택) 주의사항 또는 보충 설명
export const TABLE_DESCRIPTIONS = {
  users: {
    label: '직원 계정 · 인증 정보',
    pages: ['직원 관리', '마케팅 명단', '로그인/인증', '출퇴근 참조'],
  },
  attendances: {
    label: '직원 출퇴근 기록',
    pages: ['출퇴근 관리', '직원 대시보드'],
    note: 'check_in/check_out은 UTC 저장 → 표시 시 KST 변환',
  },
  attendance_checkout_requests: {
    label: '직원 조기퇴근 요청',
    pages: ['출퇴근 관리 (승인)', '직원 대시보드 (신청)'],
  },
  attendance_schedule_overrides: {
    label: '출퇴근 예외 스케줄 (특정 직원·날짜 범위 근무시간 덮어쓰기)',
    pages: ['출퇴근달력 관리'],
    note: 'user_id=NULL이면 전체 직원 공통 적용. 날짜 범위 오버라이드 지원',
  },
  attendance_calendar_audit_logs: {
    label: '출퇴근달력 변경이력 (오버라이드 CRUD + 관리자 출퇴근 직접 수정)',
    pages: ['출퇴근달력 관리 (감사 로그)'],
    note: 'table_name: attendance_schedule_overrides | attendances',
  },
  leaves: {
    label: '연차 사용 기록',
    pages: ['연차 관리', '연차정산', '직원 대시보드'],
  },
  tm_score_rule_versions: {
    label: 'TM 월간 점수 기준표 (회사별·적용월별)',
    pages: ['점수 관리'],
    note: 'config(JSONB): 구간표·초과 가산·풀타임 기준선·파트 배율. 각 월은 그 달에 유효한 버전으로 계산',
  },
  tm_score_manual_inputs: {
    label: 'TM 월간 점수 직접 입력 (화합·기타)',
    pages: ['점수 관리'],
    note: '행이 없으면 기준표의 기본점수(10점) 적용. 자동 항목은 저장하지 않고 실시간 집계',
  },
  allowed_ips: {
    label: '접속 허용 IP 목록',
    pages: ['IP 관리'],
    note: '등록된 IP만 출근 처리 허용',
  },
  ip_aliases: {
    label: 'IP 주소 별칭/라벨',
    pages: ['IP 관리', '출퇴근 관리'],
    note: '출퇴근 기록에 IP 이름으로 표시됨',
  },
  login_presence: {
    label: '온라인 직원 현황 (로그인 상태)',
    pages: ['현황판 (SituationBoard)'],
  },
  refresh_tokens: {
    label: 'JWT 리프레시 토큰',
    pages: ['로그인/인증 (자동 갱신)'],
    note: '민감 데이터 — token_hash는 항상 마스킹됨',
  },
  audit_logs: {
    label: 'API 호출 이력 (전체 로그)',
    pages: ['로그 관리', '직원 내 활동 로그'],
    note: '모든 /api 요청이 자동 기록됨',
  },
  app_settings: {
    label: '앱 전역 설정값 (key-value 저장소)',
    pages: ['출퇴근 설정 (출근 시간 기준 등)', '운영 공통 설정'],
    note: '전역 설정 저장소입니다. 기존 통합관리설정 키는 통합 메뉴 관리 구조로 대체되어 더 이상 사용하지 않습니다.',
  },
  tm_calls: {
    label: '일일콜현황 입력 데이터',
    pages: ['일일콜현황 (직원)', '계약 (콜현황 검색)'],
    note: 'is_contracted=true 행은 contracts 테이블과 1:1 연결',
  },
  contracts: {
    label: '계약 완료 데이터 (tm_calls와 1:1)',
    pages: ['계약'],
    note: 'tm_call_id로 tm_calls 참조. 계약 수정은 contracts만 업데이트',
  },
  ticket_types: {
    label: '상품 정의 (이름, 가격, 유효기간)',
    pages: ['상품 관리', '계약 (상품 선택)'],
  },
  product_categories: {
    label: '상품 카테고리 (제주/영화 등)',
    pages: ['상품 관리', '일일콜현황 (상품 드롭다운)'],
    note: '회사마다 쓸 분류는 상품 관리 > 회사에 붙이기에서 정합니다 (is_internal 은 레거시)',
  },
  feedback_options: {
    label: '콜 결과 피드백 선택지',
    pages: ['일일콜현황 (결과 드롭다운)'],
  },
  tm_user_preferences: {
    label: '일일콜현황 사용자 개인 설정',
    pages: ['일일콜현황'],
  },
  promotional_suppliers: {
    label: '홍보물 발주처 마스터 (발주처명, 기본택배사)',
    pages: ['홍보물원가 관리'],
  },
  promotional_items: {
    label: '홍보물 종류 마스터 (이름, 판매가, 원가, 발주처 FK)',
    pages: ['홍보물 관리 (품목 설정)', '홍보물원가 관리'],
  },
  promotional_item_price_history: {
    label: '홍보물 판매가·원가 변경 이력 (최초 등록 포함)',
    pages: ['홍보물원가 관리'],
    note: 'price 또는 cost_price 변경 시 자동 기록',
  },
  promotional_orders: {
    label: '홍보물 주문 헤더 (고객 정보)',
    pages: ['홍보물 관리'],
    note: 'items는 promotional_order_items에 별도 저장',
  },
  promotional_order_items: {
    label: '홍보물 주문 명세 (품목별 수량·택배)',
    pages: ['홍보물 관리'],
    note: 'courier/tracking_number는 아이템 단위로 관리. is_ordered/ordered_by/is_cancelled 컬럼으로 발주/취소 관리',
  },
  promotional_order_history: {
    label: '홍보물 주문 변경 이력 (전체 감사 로그)',
    pages: ['홍보물 관리 (이력 모달)'],
    note: 'action: order_created·item_ordered·item_order_cancelled·shipping_updated·item_cancelled·item_restored·step_changed·started·start_cancelled. old_value/new_value는 JSONB.',
  },
  workflow_types: {
    label: '업무단계 타입 정의',
    pages: ['계약 (업무단계 배지)', '홍보물 관리 (업무단계 배지)'],
  },
  workflow_steps: {
    label: '업무단계 세부 항목',
    pages: ['계약 (업무단계 배지)', '홍보물 관리 (업무단계 배지)'],
  },
  user_task_assignments: {
    label: '직원별 업무/기능 배정',
    pages: ['업무 배정 관리'],
  },
  feature_sets: {
    label: '기능 세트 정의 (접근 가능 메뉴 묶음)',
    pages: ['업무 배정 관리'],
  },
  user_feature_sets: {
    label: '직원 ↔ 기능세트 연결 테이블',
    pages: ['업무 배정 관리', '직원 메뉴 권한'],
  },
  quotes: {
    label: '견적서 (발행번호·품목·수량·단가)',
    pages: ['견적서 관리'],
    note: 'quote_number는 JU#### 형식으로 자동 채번. vat_yn(부가세 여부), free_items(무상제공품목)',
  },
  system_settings: {
    label: '시스템 설정 (key-value 저장소)',
    pages: ['견적서 관리 (도장 이미지)'],
    note: 'key=stamp_image: 도장 이미지 base64 문자열 저장. 향후 확장 가능.',
  },
  revenue_card_batches: {
    label: '카드승인 파일 업로드 배치 이력',
    pages: ['매출 관리 (카드승인 탭)'],
    note: '엑셀/CSV 파일 1건 업로드 = 1개 배치. total_rows/new_count/updated_count/skipped_count 집계.',
  },
  revenue_card_approvals: {
    label: '카드승인 내역 (신용거래내역 파일)',
    pages: ['매출 관리 (카드승인 탭)'],
    note: 'approval_no UNIQUE — 중복 업로드 시 fee·expected_payment_amount·expected_payment_date만 갱신. terminal_id → users.terminal_id 매핑으로 마케터 자동 연결.',
  },
  revenue_tax_invoices: {
    label: '세금계산서 (청구/영수)',
    pages: ['매출 관리 (세금계산서 탭)'],
    note: '여러 입금(revenue_payments)이 1개 세금계산서를 참조하는 N:1 구조. issue_type: 청구|영수.',
  },
  revenue_payments: {
    label: '입금 내역',
    pages: ['매출 관리 (입금 탭)'],
    note: 'tax_invoice_id로 세금계산서 참조(nullable). user_id = 담당 마케터(정산서 연동 예정).',
  },
  revenue_card_phone_approvals: {
    label: '카드전화승인 내역 (수기 입력)',
    pages: ['매출 관리 (카드전화승인 탭)'],
    note: '카드사·결제일·영업자(마케터)·결제금액 수기 입력. 파일 업로드 아님.',
  },
  revenue_others: {
    label: '기타 매출 내역',
    pages: ['매출 관리 (기타 탭)'],
    note: '날짜·금액·설명·담당자 자유 형식 입력.',
  },
  revenue_audit_logs: {
    label: '매출 데이터 변경이력 (감사 로그)',
    pages: ['매출 관리 (이력 조회)'],
    note: 'action: create·update·delete. 입금·세금계산서·카드전화승인·기타 수정 추적. old_values/new_values는 JSONB.',
  },
  impersonation_logs: {
    label: '관리자 위장 접속 이력 (직원페이지 접속 이벤트)',
    pages: ['직원페이지', '로그 관리'],
    note: '관리자가 "직원페이지" 기능으로 직원 계정에 접속할 때마다 기록됨. 삭제하지 마세요.',
  },
  external_companies: {
    label: '외부 회사 정보 (관리 대상 외부 파트너사)',
    pages: ['외부 회사 관리', '사이드바 메뉴 (외부 회사별 서브메뉴)', '업무/기능 배정'],
    note: 'code: 권한코드 접두사용 식별자(대문자). enabled_features JSONB: { attendance, leave, call } — false면 해당 기능 숨김. is_active=false면 비활성화.',
  },
  permissions: {
    label: '권한 코드 정의 (기능별 접근 허용 코드 마스터)',
    pages: ['업무/기능 배정', '외부 회사 관리'],
    note: '외부 회사 등록 시 EXTERNAL_{CODE}_(USER|ATTENDANCE|LEAVE|TM_CALL)_MANAGEMENT 4개 자동 생성. 회사 삭제 시 함께 삭제됨.',
  },
};

// ─── 컬럼 타입 뱃지 색상 맵 ────────────────────────────────────────────────
export const TYPE_COLORS = {
  integer:           { bg: '#eff6ff', text: '#1d4ed8' },
  bigint:            { bg: '#eff6ff', text: '#1d4ed8' },
  smallint:          { bg: '#eff6ff', text: '#1d4ed8' },
  numeric:           { bg: '#eff6ff', text: '#1d4ed8' },
  boolean:           { bg: '#f0fdf4', text: '#15803d' },
  text:              { bg: '#fdf4ff', text: '#7e22ce' },
  'character varying': { bg: '#fdf4ff', text: '#7e22ce' },
  date:              { bg: '#fff7ed', text: '#c2410c' },
  timestamp:         { bg: '#fff7ed', text: '#c2410c' },
  'timestamp without time zone': { bg: '#fff7ed', text: '#c2410c' },
  'timestamp with time zone':    { bg: '#fff7ed', text: '#c2410c' },
  jsonb:             { bg: '#fefce8', text: '#a16207' },
  json:              { bg: '#fefce8', text: '#a16207' },
  serial:            { bg: '#f0f9ff', text: '#0369a1' },
};
